import React from "react";
import "./ListingLayout.scss";

const ListingLayout = ({ children, props }) => {
  return <div className="listing-layout">{children}</div>;
};

export default ListingLayout;
